export default __webpack_public_path__ + "static/media/0x4455ef8b4b4a007a93daa12de63a47eeac700d9d.30a6e34b.webp";